import React, { useEffect, useId, useRef } from 'react';
import { createPortal } from 'react-dom';
import { FaTimes } from 'react-icons/fa';

const dialogs = [];
let previousOverflow = '';
let background = [];
export default function CustomerDialog({ title, subtitle, icon: Icon, onClose, children, footer, actions, busy = false, className = '' }) {
  const titleId = useId();
  const panel = useRef(null);
  const close = useRef(onClose); close.current = onClose;
  const pending = useRef(busy); pending.current = busy;
  useEffect(() => {
    const token = Symbol('customer-dialog');
    const before = document.activeElement;
    const backdrop = panel.current?.closest('.customer-dialog-backdrop');
    if (!dialogs.length) {
      previousOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden';
      background = [...document.body.children].filter(node => node !== backdrop).map(node => ({ node, inert: node.inert }));
      background.forEach(({ node }) => { node.inert = true; });
    }
    dialogs.push({ token, backdrop });
    dialogs.forEach(item => { if (item.backdrop) item.backdrop.inert = item.token !== token; });
    const focusable = () => [...(panel.current?.querySelectorAll('button:not(:disabled), a[href], input:not(:disabled), select:not(:disabled), textarea:not(:disabled), [tabindex="0"]') || [])].filter(node => !node.closest('[hidden]'));
    const timer = setTimeout(() => (focusable().find(node => node.matches('input,select,textarea')) || panel.current)?.focus(), 0);
    const keys = event => {
      if (dialogs[dialogs.length - 1]?.token !== token || event.defaultPrevented) return;
      if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); if (!pending.current) close.current(); }
      if (event.key === 'Tab') {
        const nodes = focusable(), first = nodes[0], last = nodes[nodes.length - 1];
        if (!first) { event.preventDefault(); panel.current?.focus(); return; }
        if (event.shiftKey && (document.activeElement === first || document.activeElement === panel.current)) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && (document.activeElement === last || document.activeElement === panel.current)) { event.preventDefault(); first.focus(); }
      }
    };
    document.addEventListener('keydown', keys);
    return () => {
      clearTimeout(timer); document.removeEventListener('keydown', keys);
      dialogs.splice(dialogs.findIndex(item => item.token === token), 1);
      dialogs.forEach((item, index) => { if (item.backdrop) item.backdrop.inert = index !== dialogs.length - 1; });
      if (!dialogs.length) {
        document.body.style.overflow = previousOverflow;
        background.forEach(({ node, inert }) => { node.inert = inert; }); background = [];
      }
      if (before?.isConnected) before.focus();
    };
  }, []);
  return createPortal(<div className="customers-ui customer-dialog-backdrop" onMouseDown={event => { if (event.target === event.currentTarget && !busy) onClose(); }}>
    <section ref={panel} role="dialog" aria-modal="true" aria-labelledby={titleId} tabIndex={-1} className={'customer-dialog ' + className}>
      <header className="customer-dialog-header">
        <div className="customer-dialog-heading">{Icon && <span className="customer-dialog-icon"><Icon/></span>}<div><h2 id={titleId}>{title}</h2>{subtitle && <p>{subtitle}</p>}</div></div>
        <div className="customer-dialog-actions">{actions}<button type="button" className="customer-icon-button" aria-label="Fechar janela" onClick={onClose} disabled={busy}><FaTimes/></button></div>
      </header>
      <div className="customer-dialog-body">{children}</div>
      {footer && <footer className="customer-dialog-footer">{footer}</footer>}
    </section>
  </div>, document.body);
}
